import { Card, CardMedia, Container, Typography } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import CONTENT from "src/library/content.json";

export default function SpeakerSpotlight() {
  const {
    speakerSpotlight: { name, about, image },
  } = CONTENT;

  return (
    <Container
      maxWidth="md"
      data-aos="fade-up"
      data-aos-offset="200"
      data-aos-duration="400"
      data-aos-easing="ease-in-out"
      disableGutters
    >
      <Card
        className="card"
        sx={{
          borderRadius: 0,
          border: "1px solid black",
          boxShadow: "none",
          bgcolor: "background.primary",
        }}
      >
        <Grid container sx={{ border: "3px solid #43268B" }}>
          <Grid item xs={12} md={6}>
            <CardContent
              sx={{
                textAlign: "left",
                bottom: 0,
                m: 1,
                maxWidth: "100%",
              }}
            >
              <Typography
                color={"Orange"}
                textAlign="left"
                variant="h5"
                component="p"
                fontWeight="fontWeightExtraBold"
              >
                {name}
              </Typography>
              <Typography variant="body1" fontSize={"1.05rem"} component="p" py={2}>
                {about}
              </Typography>
            </CardContent>
          </Grid>
          <Grid item xs={12} md={6}>
            <CardMedia
              component="img"
              image={image}
              sx={{
                objectFit: "contain",
                margin: "auto",
                display: "block",
                maxWidth: "100%",
                maxHeight: "100%",
              }}
            ></CardMedia>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
}
